import { partial } from 'lodash';

import isZapInFolder from './isZapInFolder';

const TRASH_FOLDER_ID = 'trash';

const isZapInTrash = partial(isZapInFolder, TRASH_FOLDER_ID);

export default isZapInTrash;
